import angular from "angular"
import uiRouter from "angular-ui-router"
import moment from "moment"
import { dateAsString } from "../shared/utils"
import { getCampsiteNameForBookingUrl } from "../utils/anytime"

let dragDistance = 0

angular.module("makeamapAngularApp.imgError", []).directive("imgError", [
  "$parse",
  function ($parse) {
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        const fn = $parse(attrs.imgError)
        element.on("error", function (event) {
          scope.$apply(function () {
            fn(scope.$parent)
          })
        })
      },
    }
  },
])

export class MarkerDetailController {
  /*@ngInject*/
  constructor($scope, $window, $timeout, $location, $state, anytimeService) {
    this.anytimeService = anytimeService
    this.$scope = $scope
    this.$window = $window
    this.$timeout = $timeout
    this.actualYPosition
    this.scrollDistance
    this.$location = $location
    this.isExpanded = false
    this.markerDetailStyle = {}
    this.$state = $state
    this.imageLoadFailed = false
  }

  onImageError() {
    this.$timeout(() => {
      this.imageLoadFailed = true
    })
  }

  openGallery() {
    this.showFullscreenGallery()
  }

  openPanel() {
    let imgDragStyle = {
      visibility: "visible",
      transition: "transform 0.3s",
    }

    let dragStyle = {
      "z-index": 1,
    }

    Object.assign(dragStyle, imgDragStyle)

    this.dragStyle = this.setTransformStyle(dragStyle, -this.eightyPercentPixelValue)
    this.imagePositionStyle = this.setTransformStyle(imgDragStyle, -this.$window.innerHeight)

    this.isExpanded = true

    this.markerDetailStyle["pointer-events"] = `all`

    this.actualYPosition = -this.eightyPercentPixelValue
  }

  hmPanEnd() {
    if (dragDistance < -10) {
      this.openPanel()
      dragDistance = 0
    }
  }

  getDragStyles() {
    let imgDragStyle = {
      visibility: "visible",
      transition: "none",
    }

    let dragStyle = {
      "z-index": 1,
    }

    Object.assign(dragStyle, imgDragStyle)

    return [dragStyle, imgDragStyle]
  }

  hmDrag(ev) {
    if (ev.deltaY < -10) {
      let dragStyles = this.getDragStyles()
      this.dragStyle = this.setTransformStyle(dragStyles[0], ev.deltaY - 122)
      this.imagePositionStyle = this.setTransformStyle(dragStyles[1], 1.35 * (ev.deltaY - 80))

      dragDistance = ev.deltaY
    }
  }

  setTransformStyle(target, distance) {
    return Object.assign(target, this.getTransformStyles(distance))
  }

  getTransformStyles(distance) {
    return {
      "-ms-transform": `translateY(${distance}px)`,
      "-webkit-transform": `translateY(${distance}px)`,
      transform: `translateY(${distance}px)`,
    }
  }

  hmPanStartTopArea() {
    if (this.isExpanded) {
      this.isExpanded = false
    }
  }

  hmDragTopArea(ev) {
    if (ev.deltaY > 10) {
      let dragStyles = this.getDragStyles()
      this.dragStyle = this.setTransformStyle(dragStyles[0], -this.eightyPercentPixelValue + ev.deltaY)
      this.imagePositionStyle = this.setTransformStyle(
        dragStyles[1],
        1.35 * (-this.eightyPercentPixelValue + ev.deltaY)
      )

      dragDistance = ev.deltaY
    }
  }

  goBack() {
    if (this.availableMarkersShowing) {
      this.$state.go("mainmap.home.availability-status")
      // todo perhaps if in iframe should zoom out to filtered markers here
    } else {
      this.$state.go("mainmap.home")
    }
  }

  closePanel() {
    this.dragStyle = {
      visibility: "hidden",
    }
    this.imagePositionStyle = {
      visibility: "hidden",
    }

    this.isExpanded = false
    this.markerDetailStyle["pointer-events"] = `none`
  }

  hmPanEndTopArea() {
    if (dragDistance > -10) {
      this.closePanel()
      dragDistance = 0
    }
  }

  // todo functionality here for extra content in future, disabled for now
  // hmPanEndBottomArea() {
  //   this.actualYPosition = this.actualYPosition + this.scrollDistance;
  // }

  // hmDragBottomArea(ev) {
  //   let transformDistance = this.actualYPosition + ev.deltaY;
  //   console.log(transformDistance);
  //   if(-transformDistance > this.eightyPercentPixelValue && transformDistance > -800) {
  //     let dragStyles = this.getDragStyles();
  //     this.dragStyle = this.setTransformStyle(dragStyles[0], transformDistance);

  //     //currently the image area doesn't move when swiping for extra content, if we were to do this
  //     // then would need to tranck another actualYPosition for the image area seperately.
  //     // this.imagePositionStyle = this.setTransformStyle(dragStyles[1], transformDistance);
  //     this.scrollDistance = ev.deltaY;
  //   }

  //  dragDistance = ev.deltaY;
  // }

  getEightyPercentPixelValue() {
    return this.$window.innerHeight * 0.74
  }

  getPitchTypeData(pitchtype) {
    return this.campsiteData.pitchtypes.find((pitchtypeoption) => pitchtypeoption.type === pitchtype)
  }

  getPitchTypeSubTypeData(pitchTypeData, pitchTypeSubType) {
    return pitchTypeData.subTypes.find((subType) => subType.name === pitchTypeSubType)
  }

  getPitchServices(pitchtype) {
    if (pitchtype.services && pitchtype.services.length > 0) {
      return pitchtype.services.map((service) => service.toLowerCase())
    }

    return null
  }

  getPitchSurfaceType(pitchtype) {
    return pitchtype.surface
  }

  getTypeString() {
    const markerType = this.transitionParams.markers
    return markerType === "pitch" ? "pitches" : markerType === "facility" ? "facilities" : "surroundings"
  }

  shouldUseSubTypeImage() {
    return (
      this.selectedMarker.pitchTypeSubType &&
      this.selectedmarker.pitchTypeSubTypeData &&
      this.selectedmarker.pitchTypeSubTypeData.overridePitchTypeImage
    )
  }

  $onChanges(changes) {
    if (changes.selectedMarker && changes.selectedMarker.currentValue) {
      this.selectedmarker = changes.selectedMarker.currentValue
      this.imageLoadFailed = false
      let typeString = this.getTypeString()
      this.standardServices = null
      this.additionalServices = null

      if (typeString === "pitches") {
        this.pitchName = this.selectedmarker.name
        const pitchTypeData = this.selectedmarker.pitchTypeData
        if (pitchTypeData) {
          this.markerDescription = pitchTypeData.description
          // for anytime the description showing appears to just be the `extradesc` stored on the pitch data
          this.selectedmarker.services = this.getPitchServices(pitchTypeData)
          this.selectedmarker.surfacetype = this.getPitchSurfaceType(pitchTypeData)
        }

        if (this.selectedmarker.services?.length) {
          this.standardServices = this.selectedmarker.services.filter(
            (service) => service === "electric" || service === "tv" || service === "drainage" || service === "water"
          )
          this.additionalServices = this.selectedmarker.services.filter(
            (service) => this.standardServices.indexOf(service) === -1
          )
        }

        if (this.campsiteData.isPitchImageBasedOnType && !this.selectedmarker.overridePitchImage) {
          const shouldUseSubTypeImage = this.shouldUseSubTypeImage()
          this.singleImageUrl = `${this.getBaseString()}${this.simplifyUrlString(
            shouldUseSubTypeImage ? this.selectedMarker.pitchTypeSubType : this.selectedMarker.pitchtype
          )}.jpg`
        } else {
          this.singleImageUrl = this.getUrlstringIdSingleUrl()
        }

        this.setUnitMarkerDetails()

        this.startDateAsMoment = this.startDate ? moment(this.startDate) : null
        this.endDateAsMoment = this.endDate ? moment(this.endDate) : null
        this.startDatePresentable = this.startDateAsMoment ? this.getPresentableDate(this.startDateAsMoment) : null
        this.endDatePresentable = this.endDateAsMoment ? this.getPresentableDate(this.endDateAsMoment) : null
      } else {
        this.singleImageUrl = this.getUrlstringIdSingleUrl()
        this.markerDescription = this.selectedmarker.desc
      }

      // wonder if pitch image is based on type should even be an option
    }

    //  this for gemapark only
    if (this.campsiteData.booksystemname === "GemaPark") {
      if (changes.allUnitsData || changes.availabilityPitchNameData) {
        if (this.allUnitsData || this.availabilityPitchNameData) {
          let typeString = this.getTypeString()
          if (typeString === "pitches") {
            this.setUnitMarkerDetails()
          }
        }
      }
    }

    if (this.campsiteData.booksystemname === "Anytime" && this.startDate) {
      const lengthOfStay = moment(this.endDate).diff(moment(this.startDate), "days")
      this.anytimeService
        .getMinNightsAndPricing(this.campsiteData.name)
        .then((anytimeMinNightsAndPricingDataAllUnits) => {
          const anytimeUnitPriceForDuration = this.anytimeService.getAnytimeUnitPriceForDuration(
            anytimeMinNightsAndPricingDataAllUnits,
            this.startDate,
            this.accomodationType,
            lengthOfStay
          )
          this.anytimePriceForUnitTypeString = `£${anytimeUnitPriceForDuration}`
        })
    }
    // for anytime can still present unit description from unit data which is stored on availabilityPitchNameData
    // name: unit.name,
    //       physicalUnitId: unit.id,
    //       description: unit.description,
    // this.$timeout(() => {
    //   this.openPanel()
    // }, 500)

    this.showBackButton = this.$state.current.name === "mainmap.markers.detail"
  }

  getMarkerDataByPhysicalId() {
    if (this.availabilityPitchNameData) {
      const item = this.availabilityPitchNameData.find(
        (item) => item.physicalUnitId === this.selectedmarker.physicalunitids[0]
      )
      return item
    }
    return null
  }

  onClickBookPitch() {
    if (this.campsiteData.booksystemname === "GemaPark") {
      this.bookGemaParkByPitch()
    }

    if (this.campsiteData.booksystemname === "Anytime") {
      // if no dates set etc clicking booknow button should open the date picker to show availability

      if (!this.selectedmarker.isAvailable || !this.startDate || !this.endDate) {
        // TODO needs to tell main map to open the availability check view
        this.handleAvailabilityButtonClick()
      } else {
        const startDateAsMoment = moment(this.startDate).startOf("day")
        const endDateAsMoment = moment(this.endDate).startOf("day")
        const physicalUnitId = this.selectedmarker.physicalunitids[0]
        // if (!this.accomodationUnitId || !this.categoryId) {
        const markerData = this.getMarkerDataByPhysicalId(physicalUnitId)
        this.accomodationUnitId = markerData?.unitId
        this.categoryId = markerData?.categoryId
        //}
        const startDateAsString = dateAsString(startDateAsMoment, true)
        const lengthOfStay = endDateAsMoment.diff(startDateAsMoment, "days")
        // should categoryId be 1 by default?
        const campsiteName = getCampsiteNameForBookingUrl(this.campsiteData.name)
        const url = `https://${campsiteName}.anytimebooking.eu/place_booking/preset/${this.categoryId}/${this.accomodationUnitId}/${startDateAsString}/${lengthOfStay}/${physicalUnitId}`
        this.$window.open(url)
      }
    }
  }

  setUnitMarkerDetails() {
    // perhaps physicalUnitId / unitId etc should be set on class on change
    const physicalId = this.selectedmarker?.physicalunitids[0]
    const unitId = this.selectedmarker.isMultiPhysicalUnits
      ? this.selectedmarker.unitid
      : this.unitIdsForPhysicalUnitIds && this.unitIdsForPhysicalUnitIds[physicalId]
        ? this.unitIdsForPhysicalUnitIds[physicalId]
        : this.getMarkerDataByPhysicalId(physicalId)?.unitId
    const unit = this.availablePitchTypeOptions
      ? this.availablePitchTypeOptions.find((item) => item.unitId === unitId)
      : null
    this.pitchGrossPrice = unit && unit.pricingData ? unit.pricingData[0].gross : ""

    const unitDetails = this.allUnitsData ? this.allUnitsData.find((unit) => unit.unitID === unitId) : null
    this.pitchTypeDescription = unitDetails
      ? unitDetails.name || unitDetails.description
      : this.selectedmarker.pitchtype

    if (this.campsiteData.booksystemname === "GemaPark") {
      this.pitchGemaParkDescription = this.getMarkerDataByPhysicalId(physicalId)?.notes
    }
    if (this.campsiteData.booksystemname === "Anytime") {
      this.anytimeService.getAccomodationTypes(this.campsiteData.name).then((accomodationtypes) => {
        this.accomodationType = accomodationtypes.find(
          (item) => item?.accommodationTypeID === unitId
        )?.accommodationTypeID
      })
    }

    if (unitDetails) {
      this.markerDescription = unitDetails.summary
    }
  }

  formatString(str) {
    return str.replace(/\s+/g, "_").toLowerCase()
  }

  loadImage = function (service) {
    return require(`../../assets/icons/services/${service}.svg`)
  }

  loadFacilityImage = function (str) {
    return require(`../../assets/icons/facilities/${this.formatString(str)}.svg`)
  }

  getBaseString() {
    return `https://dwf18h5sawogn.cloudfront.net/ppphotos/${this.campsiteData.name}/${this.getTypeString()}/`
  }

  simplifyUrlString(string) {
    return string.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
  }

  getPitchImageTrailingCharacters() {
    if (this.transitionParams.markers === "pitch") {
      if (this.campsiteData.pitchPhotoExtensionFrontBack) {
        return "f"
      }
    }
    return ""
  }

  getImageVersion(index) {
    if (this.selectedmarker.imageVersions && this.selectedmarker.imageVersions[index]) {
      return this.selectedmarker.imageVersions[index]
    }
    return ""
  }

  getUrlstringIdSingleUrl() {
    let imageVersion = this.getImageVersion(0)
    return `${this.getBaseString()}${
      this.selectedmarker.urlstringid
    }${this.getPitchImageTrailingCharacters()}${imageVersion}.jpg`
  }

  $onDestroy() {
    this.windowListener()
  }

  setup() {
    if (this.$window.innerWidth >= 1024) {
      this.touchEnabled = false
      // this.markerDetailStyle.height = `${this.$window.innerHeight - 85}px`
    } else {
      this.markerDetailStyle["pointer-events"] = `none`
      this.eightyPercentPixelValue = this.getEightyPercentPixelValue()
      this.touchEnabled = true
    }
  }

  $onInit() {
    this.windowListener = this.$scope.$on("watchWindowResize::resize", () => {
      this.setup()
    })

    this.setup()
  }

  getPresentableDate(momentdate) {
    let formatString = "MMM Do"
    if (moment(new Date()).year() !== momentdate.year()) {
      formatString += " YYYY"
    }
    return momentdate.format(formatString)
  }
}

export default angular
  .module("makeamapAngularApp.markerdetail", [uiRouter, "makeamapAngularApp.imgError"])
  .component("markerdetail", {
    template: require("./markerdetail.html"),
    bindings: {
      bookGemaParkByPitch: "&",
      accomodationType: "<",
      startDate: "<",
      endDate: "<",
      areaAvailablePitches: "<",
      selectedMarker: "<",
      campsiteData: "<",
      transitionParams: "<",
      availableMarkersShowing: "<",
      showFullscreenGallery: "&",
      shouldPick: "<",
      onClickSelectPitch: "&",
      onClickCheckAvailButton: "&",
      availablePitchTypeOptions: "<",
      unitIdsForPhysicalUnitIds: "<",
      allUnitsData: "<",
      availabilityPitchNameData: "<",
      skipIndividualPitchAvailability: "<",
      isPricingShowing: "<",
      isAvailabilityHidden: "<",
    },
    controller: MarkerDetailController,
    transclude: false,
  }).name
